<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget padding15">
        <div class="row mb-3 align-items-center">
            <div class="col-6">
                <h6 class="proxima-nova-bold">Client Invoices</h6>
            </div>
            <div class="col-6">
                <invoice-modal
                    v-show="clientId"
                    :client-id="clientId"
                    @invoice-added="onInvoiceAdded"
                    class="float-right"
                    
                />
            </div>
        </div>
        <select name="clients" id="clients" v-model="clientId" class="form-control mb-4">
            <option value="">Select client</option>
            <option v-for="client in clients" v-bind:value="client.id">
                {{ client.organization_name }} ({{ client.name }})
            </option>
        </select>
        <invoices
           
            :invoices="invoices"
            :show-client="false"
            :show-order="true"
            :id="id"
        />
        <!-- <div v-else class="text-black-50 text-center">
            <p class="h5 p-2">Client has no invoices.</p>
        </div> -->
    </div>
</template>

<script>
    export default {
        components: { },
        props: ['clients','id'],
        data() {
            return {
                invoices: [],
                clientId: null,
            };
        },
        watch: {
            clientId() {
                this.fetchInvoices();
            },
        },
        methods: {
            fetchInvoices() {
                axios.get('/invoices/uncategorized', {params: {client_id: this.clientId}}).then((res) => {
                    this.invoices = res.data;
                }).catch(e => {
                    console.log(e);
                });
            },
            onInvoiceAdded(){
                this.fetchInvoices();
            },
        },
    }
</script>
